import PageLoader from './Loader';

export default PageLoader;
